import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  title: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px'
  }
}))
